/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscolumnlink3Inputs */

const en_downloadlinkscolumnlink3 = /** @type {(inputs: Downloadlinkscolumnlink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const de_downloadlinkscolumnlink3 = /** @type {(inputs: Downloadlinkscolumnlink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Downloadlinkscolumnlink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscolumnlink3 = /** @type {((inputs?: Downloadlinkscolumnlink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscolumnlink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscolumnlink3(inputs)
	return de_downloadlinkscolumnlink3(inputs)
});
export { downloadlinkscolumnlink3 as "downloadLinksColumnLink" }